(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  // Variant labels using " / " to pack multiple dimensions (e.g.
  //   "24ml / 訂貨", "米色+橙色 Beige / 現貨",
  //   "粉餅補充裝 / 訂貨 / OC10" — set + stock + shade, from Shopline migration).
  // Pull the STOCK-STATUS token (現貨／訂貨) out into a small right-aligned pill
  // and keep everything else (shade code, set type) as the primary label.
  // Rationale: the shade code (OC10/OC20…) is the decision-critical attribute
  // and must stay prominent; 現貨/訂貨 is low-emphasis and belongs in the pill.
  // Earlier this took the LAST segment as the pill, which buried the shade
  // code (it sorts last in the migrated value) — see owner note 2026-06-01.
  // 2-dimension labels where 訂貨/現貨 already trail (e.g. "24ml / 訂貨") render
  // identically. If no stock token is present, fall back to last-segment pill.
  // Skips single-dimension labels. Re-runs on variant picker re-render via
  // MutationObserver.
  (function () {
    var PRIMARY_CLS = 'variant-label-primary';
    var PILL_CLS = 'variant-status-pill';
    var STOCK_TOKENS = ['現貨', '訂貨'];

    function processLabels(root) {
      var labels = (root || document).querySelectorAll(
        '.product-information.section .variant-option__button-label__text'
      );
      labels.forEach(function (el) {
        if (el.dataset.dimensionSplit) return;
        if (el.querySelector('.' + PRIMARY_CLS)) {
          el.dataset.dimensionSplit = '1';
          return;
        }
        var raw = (el.textContent || '').trim();
        if (raw.indexOf(' / ') === -1) return;
        var parts = raw.split(' / ').map(function (s) { return s.trim(); });
        var pillIdx = -1;
        for (var i = 0; i < parts.length; i++) {
          if (STOCK_TOKENS.indexOf(parts[i]) !== -1) { pillIdx = i; break; }
        }
        var primary, secondary;
        if (pillIdx !== -1) {
          // Stock token found anywhere → it becomes the pill; the rest
          // (shade + set type) joins back into the prominent primary label.
          secondary = parts[pillIdx];
          primary = parts.filter(function (_, i) { return i !== pillIdx; }).join(' / ');
        } else {
          // No stock token → original behaviour: last segment is the pill.
          secondary = parts[parts.length - 1];
          primary = parts.slice(0, -1).join(' / ');
        }
        if (!primary || !secondary) return;
        var primarySpan = document.createElement('span');
        primarySpan.className = PRIMARY_CLS;
        primarySpan.textContent = primary;
        var pillSpan = document.createElement('span');
        pillSpan.className = PILL_CLS;
        pillSpan.textContent = secondary;
        el.textContent = '';
        el.appendChild(primarySpan);
        el.appendChild(pillSpan);
        el.dataset.dimensionSplit = '1';
      });
    }

    function init() {
      processLabels();
      var pickers = document.querySelectorAll('.product-information.section variant-picker');
      pickers.forEach(function (p) {
        new MutationObserver(function () { processLabels(p); }).observe(p, {
          childList: true,
          subtree: true,
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
